import React from 'react';
import { useEffect, useState } from 'react';
import NavigationBar from '../ReusableComp/NavigationBar';
import { MarketingHeadFlow } from '../ReusableComp/NavBarLeft';
import { Container, Stack} from 'react-bootstrap';
import { useDispatch, useSelector} from 'react-redux';
import {  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,Area , Legend, BarChart, Bar, Label, ReferenceArea, AreaChart } from "recharts";
import { Card, Col, Row, Table } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router";
import Select from '../ReusableComp/Select';
import ToggleButton from 'react-toggle-button';
import { getEventFlag } from '../../Redux/actions/actions';

function MarketingHeadDashBoard() {
  const navigate = useNavigate();
  const dispatch= useDispatch();
  const mhdbcounts = useSelector((state) => state.mhdbcounts);
  const [subjectRegistered, setSubjectRegistered] = useState({});
    const [adverseEvents, setAdverseEvents] = useState({});
    const [seriousAdverseEvents, setSeriousAdverseEvents] = useState({});
    const [minVal, setMinVal] = useState(0);
    const [maxVal, setMaxVal] = useState(0);
    const [midVal, setMidVal] = useState(0);
    
  useEffect(() => {
    if(!localStorage.getItem("login_user_name")){
        navigate("/");
    }
    disableBackButton();


    if(mhdbcounts !== null && mhdbcounts !== undefined && mhdbcounts.length !=0){
      const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const newData = Object.keys(mhdbcounts?.aesCount).map((date) => ({
        name: getDayAbbreviation(date),
        "Month Wise Adverse Events Reported": mhdbcounts?.aesCount[date],
      }));
      const result1 = Object.entries(mhdbcounts?.aesCount).map(([key, value]) => {
        const [month, year] = key.split("-");
        const monthIndex = parseInt(month) - 1;
        const name = months[monthIndex] + "-" + year.slice(-2);
      
        return {
          name,
          "Month Wise Adverse Events Reported": value
        };
      });
      setAdverseEvents(result1);
      const newData1 = Object.keys(mhdbcounts?.saesCount).map((date) => ({
        name: getDayAbbreviation(date),
        " Month Wise Serious Adverse Events Reported": mhdbcounts?.saesCount[date],
      }));
      const result2 = Object.entries(mhdbcounts?.saesCount).map(([key, value]) => {
        const [month, year] = key.split("-");
        const monthIndex = parseInt(month) - 1;
        const name = months[monthIndex] + "-" + year.slice(-2);
      
        return {
          name,
          " Month Wise Serious Adverse Events Reported": value
        };
      });
      setSeriousAdverseEvents(result2);
      
      
      
      // Convert the data to the desired format
      const result = Object.entries(mhdbcounts?.subjectsEnrolled).map(([key, value]) => {
        const [month, year] = key.split("-");
        const monthIndex = parseInt(month) - 1;
        const name = months[monthIndex] + "-" + year.slice(-2);
      
        return {
          name,
          "Month Wise Subjects Registered": value,
          amt: value // You can set the "amt" value accordingly if needed
        };
      });
      setSubjectRegistered(result)
      const yValues = result?.map(item => item["Month Wise Subjects Registered"]);
      setMinVal(0);
      setMaxVal(Math.max(...yValues));
      setMidVal((0 + maxVal) / 2)
  }

  },[maxVal, mhdbcounts, navigate]);
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];


  function getDayAbbreviation(dateString) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const date = new Date(dateString);
    const dayIndex = date.getDay();
    return days[dayIndex];
  }
  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }
  const handleStudyChange = () => {
      
  }

  const handleNavigate =(card, index)=>{
     
    navigate(card.url);
    let option
    if(card.desc ==="Total Sites"){
      option = "all_sites"
    }else if(card.desc==="Total Marketing Staff"){
      option = "all_staff"
    }else if(card.desc==="Total Subjects"){
      option = "all_events"
    }
    card.option = option 

    dispatch(getEventFlag(card))
     
  }

  const dashboardCards = [
    {
        count:mhdbcounts?.site_count,
        image: './images/icons/sitecolor.svg',
        desc: 'Total Sites',
        bgcolor: 'white',
        url:"/mhsitesdetails"
    },
    {
        count: mhdbcounts?.msCount,
        image: './images/icons/marketingstaffcolor.svg',
        desc: 'Total Marketing Staff',
        bgcolor: 'white',
        url:"/marketingstafflist"
    },
    {
        count: mhdbcounts?.pi_count,
        image: './images/icons/personinshieldcolor.svg',
        desc: 'Total Principal Investigator',
        bgcolor: 'white',
    },
    {
        count: mhdbcounts?.subjectsCount,
        image: './images/icons/subjects_white.svg',
        desc: 'Total Subjects',
        bgcolor: 'white',
        url:"/mhsubjectlist"
    },
]
const data = [
  {
    name: 'Jan',
    "Month Wise Subjects Registered": 2400,
    amt: 2400,
  },
  {
    name: 'Feb',
    "Month Wise Subjects Registered": 1398,
    amt: 2210,
  },
  {
    name: 'Mar',
    "Month Wise Subjects Registered": 9800,
    amt: 2290,
  },
  {
    name: 'Apr',
    "Month Wise Subjects Registered": 3908,
    amt: 2000,
  },
  {
    name: 'May',
    "Month Wise Subjects Registered": 4800,
    amt: 2181,
  },
  {
    name: 'Jun',
    "Month Wise Subjects Registered": 3800,
    amt: 2500,
  },
  {
    name: 'Jul',
    "Month Wise Subjects Registered": 4300,
    amt: 2100,
  },
  {
    name: 'Aug',
    "Month Wise Subjects Registered": 4800,
    amt: 2181,
  },
  {
    name: 'Sep',
    "Month Wise Subjects Registered": 3800,
    amt: 2500,
  },
  {
    name: 'Oct',
    "Month Wise Subjects Registered": 4300,
    amt: 2100,
  },
  {
    name: 'Nov',
    "Month Wise Subjects Registered": 4800,
    amt: 2181,
  },
  {
    name: 'Dec',
    "Month Wise Subjects Registered": 6900,
    amt: 2500,
  },
  
];
const datatwo = [
  {
    name: 'Sun',
    "Last 7 days reported Adverse Events": 340,
    amt: 2400,
  },
  {
    name: 'Mon',
    "Last 7 days reported Adverse Events": 240,
    amt: 2210,
  },
  {
    name: 'Tue',
    "Last 7 days reported Adverse Events": 280,
    amt: 2290,
  },
  {
    name: 'Wed',
    "Last 7 days reported Adverse Events": 190,
    amt: 2000,
  },
  {
    name: 'Thu',
    "Last 7 days reported Adverse Events": 200,
    amt: 2181,
  },
  {
    name: 'Fri',
    "Last 7 days reported Adverse Events": 250,
    amt: 2500,
  },
  {
    name: 'Sat',
    "Last 7 days reported Adverse Events": 380,
    amt: 2100,
  },
];
const onMouseEnter = ()=>{
  
}
const [toggleSAE, setToggleSAE] = useState(false);


  const RoundedBar = (props) => {
    const { fill, x, y, width, height } = props;
    const barWidth = width / 4; // Set the width to one-fourth of the available width
  
    return <path d={getPath(x, y, barWidth, height)} stroke="none" fill={fill} />;
  };

  const getPath = (x, y, width, height) => {
    const borderRadius = 10; 
    const barWidth = width / 1; 
    const halfWidth = barWidth / 0.66;
    
    return `M${x + halfWidth},${y + height - borderRadius}
      L${x + halfWidth},${y + borderRadius}
      Q${x + halfWidth},${y},${x + halfWidth + borderRadius},${y}
      L${x + halfWidth + barWidth - borderRadius},${y}
      Q${x + halfWidth + barWidth},${y},${x + halfWidth + barWidth},${y + borderRadius}
      L${x + halfWidth + barWidth},${y + height - borderRadius}
      Q${x + halfWidth + barWidth},${y + height},${x + halfWidth + barWidth - borderRadius},${y + height}
      L${x + halfWidth + borderRadius},${y + height}
      Q${x + halfWidth},${y + height},${x + halfWidth},${y + height - borderRadius}
      Z`;
  };
  const mhMainStudies = useSelector((state) => state.mhMainStudies);
  const generateString = (n) => {
    const array = [];
    for (let i = 1; i <= n; i++) {
      array.push(`D${i}`);
    }
    return array.join(',');
  };
  return (
    <div>
            <NavigationBar title={'Dashboard'} handleFilteredData={handleStudyChange}/>
            {/* <MarketingHeadFlow /> */}
            <div className='main_body '>
                <Container fluid className='p-4'>
                <Stack >
                {mhMainStudies &&
                    <ul className='pidblistitems  d-flex flex-row p-2 '>
                      {mhMainStudies?.map(study => {
                            if (study.study_id === localStorage.study_id) {
                              return (
                                <React.Fragment key={study.study_id}>
                                  <li><b>Study Name:</b> {study.study_name}</li>
                                  <li><b>Doses: </b> {generateString(study.number_of_doses)}</li>
                                  <li><b>Estimated Subjects: </b>{study.estimated_subjects}</li>
                                  <li><b>Estimated Sites: </b>{study.estimated_sites}</li>
                                  <li><b>Study Initiation Date: </b>{study.study_initiation_date}</li>
                                  




                                  {/* <li><b>Duration Between Doses:</b> {study.duration_between_doses} {listItems.duration_between_doses_type}</li> */}
                                  {/* <li><b>Age Group: </b>{study.age_group}</li> */}
                                </React.Fragment>
                              );
                            }
                            return null; // Return null for other studies
                          })}
                    </ul>
                  }
                  </Stack>
                <Stack direction="horizontal" gap={3} className="  px-4">
                            <div xs={3} className="ms-auto">
                                <button className="orange_btn" onClick={() =>navigate('/mhaddstaff')}>Add Staff</button>
                            </div>
                        </Stack>
                </Container>
                <Container fluid className="px-4">
                                <Row>
                                    {dashboardCards.map((card, index) => {
                                        return (
                                            <Col xs={12} md={3}>
                                                <div className={`card-container  ${card.desc== "Total Principal Investigator"?"":"C-pointer"} `} onClick={() => handleNavigate(card, index)} style={{ backgroundColor: card.bgcolor, color: "black" }}>
                                                    <div className='content' style={{color: "black"}}>
                                                        <span>{card.count}</span>
                                                        <img src={card.image} style={{color: "black"}} alt="" />
                                                    </div>
                                                    <div className='desc'>{card.desc}</div>
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </Row>

                </Container>
                <Container fluid className='px-4'>

                                <Row>
                                    <Col>
                                        <Card className='pidbcard'>
                                            <Card.Body className=''>
                                                <Card.Title className='mb-3 '>Subjects Enrolled</Card.Title>                             
                                                    <LineChart
                                                        width={530}
                                                        height={300}
                                                        data={subjectRegistered}
                                                        margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                                                        className=''
                                                        >
                                                        <CartesianGrid strokeDasharray=" 0" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip />
                                                        <Legend />
                                                        <Line type="monotone" dataKey="Month Wise Subjects Registered" stroke="#eb9c09"  dot={null}/>
                                                    </LineChart>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col xs={12} md={6} className='p-0'>
                                <Card className='pidbcard'>
                                    
                                    {!toggleSAE ? 
                                    <Card.Body>
                                        <Card.Title className='mb-3 db_chart_title' style={{display:"flex", justifyContent:"space-between"}}>
                                            Adverse Events Reported 
                                            <span style={{display:"flex"}}>
                                            <span>Serious:   </span>
                                            <span style={{marginLeft:"10px"}}>
                                            <ToggleButton value={toggleSAE}
                                            onToggle={() => {
                                                setToggleSAE(!toggleSAE);
                                            }}
                                            inactiveLabel={"No"}
                                            activeLabel={"Yes"}
                                            colors={{
                                                activeThumb: {
                                                    base: "rgb(250,250,250)",
                                                },
                                                active: {
                                                    base: "rgb(209, 65, 65)",
                                                },
                                                inactive: {
                                                    base: "rgb((0, 128, 0)",
                                                },
                                            }}
                                        />
                                        </span>
                                        </span>
                                        </Card.Title> 
                                        <BarChart width={window.screen.width >720 ?530 : 300} barGap={10} height={300} data={adverseEvents} margin={{ top: 5, right: 5, bottom: 5, left: 5 }} className='responsive-chart'>

                                          <CartesianGrid strokeDasharray="0" />
                                          <XAxis dataKey="name" tick={{ fontSize: 14 }}/>
                                          <YAxis tick={{ fontSize: 14 }}>
                                            <Label dy={-35} value="# of Adverse Events" offset={10} position="insideBottomLeft" angle={-90} fontSize={14} />
                                          </YAxis>
                                          <Tooltip />
                                          <Legend/>
                                          <Bar dataKey="Month Wise Adverse Events Reported" maxBarSize={50} fill="#EA9E4F" shape={<RoundedBar/>} onMouseEnter={onMouseEnter} />
                                        </BarChart>
                                        
                                        </Card.Body>
                                        : 
                                        <Card.Body>
                                        <Card.Title className='mb-3 db_chart_title' style={{display:"flex", justifyContent:"space-between"}}>
                                        Serious Adverse  Events  Reported 
                                        <span style={{display:"flex"}}>
                                        <span>Serious:   </span>
                                        <span style={{marginLeft:"10px"}}>
                                        <ToggleButton value={toggleSAE}
                                        onToggle={() => {
                                            setToggleSAE(!toggleSAE);
                                        }}
                                        inactiveLabel={"No"}
                                        activeLabel={"Yes"}
                                        colors={{
                                            activeThumb: {
                                                base: "rgb(250,250,250)",
                                            },
                                            active: {
                                                base: "rgb(209, 65, 65)",
                                            },
                                            inactive: {
                                                base: "rgb((0, 128, 0)",
                                            },
                                        }}
                                    />
                                    </span>
                                    </span>
                                    </Card.Title>
                                    <BarChart width={window.screen.width >720 ?530 : 300} barGap={10} height={300} data={seriousAdverseEvents} margin={{ top: 5, right: 5, bottom: 5, left: 5 }} className='responsive-chart'>
                                    <CartesianGrid strokeDasharray="0" />
                                    <XAxis dataKey="name" tick={{ fontSize: 14 }}/>
                                    <YAxis tick={{ fontSize: 14 }}>
                                      <Label dy={-10} value="# of Serious Adverse Events" offset={10} position="insideBottomLeft" angle={-90} fontSize={14} />
                                    </YAxis>
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey=" Month Wise Serious Adverse Events Reported" fill="#EA9E4F" shape={<RoundedBar/>} onMouseEnter={onMouseEnter} />
                                  </BarChart>
                                  </Card.Body>
                                    }     
                                </Card>
                            </Col>
                                </Row>
                </Container>

                <Container fluid className='px-4'>

                                <Row>
                                    <Col>
                                        <Card className='pidbcard'>
                                            <Card.Body className=''>
                                                <div  style={{display:"flex",flexDirection:"row", justifyContent:"space-between"}}>
                                                    <div>
                                                      <span>Number of Subjects by Site</span>
                                                    </div>
                                                    <div>
                                                      <p style={{padding:"0px", margin:"0px"}}>Top 15</p>
                                                    </div>
                                                  </div>
                                                  <div style={{border:"1px solid #EAEAEA", width:"100%", height:"1px"}}></div>
                                                {mhdbcounts && mhdbcounts?.subjectsPerSite.map((site) => {
                                                  return(
                                                  <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", padding:"10px"}}>
                                                    <span>{site.site_name}</span>
                                                    <div style={{display:"flex"}}>
                                                      <span style={{paddingRight:"10px"}}>{site.count}</span>
                                                      <AreaChart 
                                                          width={80}
                                                          height={20}
                                                          data={mhdbcounts?.subjectsPerSitePerMonth?.filter(item => item.site_name === site.site_name).map((item) => {
                                                            const month = item.month;
                                                            const monthIndex = parseInt(month) - 1;
                                                            const name = months[monthIndex]
                                                          
                                                            return {
                                                              name,
                                                              "Month Wise Subjects Registered": item.count,
                                                              amt: item.count // You can set the "amt" value accordingly if needed
                                                            };
                                                          })}
                                                          margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                                                          className=''
                                                          >
                                                            <defs>
                                                              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                                                              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                                                              </linearGradient>
                                                            </defs>
                                                          <Area type="monotone" dataKey="Month Wise Subjects Registered" stroke="#82ca9d" fillOpacity={1} fill="url(#colorUv)"  dot={null}/>
                                                      </AreaChart >
                                                    </div>
                                                  </div>
                                                  )
                                                }
                                                
                                                )

                                                }                         
                                                
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card className='pidbcard'>
                                            <Card.Body>
                                                
                                                <div  style={{display:"flex",flexDirection:"row", justifyContent:"space-between"}}>
                                                    <div>
                                                      <span>Number of Subjects by Event</span>
                                                    </div>
                                                    <div>
                                                      <p style={{padding:"0px", margin:"0px"}}>Top 15</p>
                                                    </div>
                                                </div>
                                                <div style={{border:"1px solid #EAEAEA", width:"100%", height:"1px"}}></div>
                                                {mhdbcounts && mhdbcounts?.subjectsPerAE.map((site) => {
                                                  return(
                                                  <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", padding:"10px"}}>
                                                    <span>{site.study_ae_bank_event_title}</span>
                                                    <div style={{display:"flex"}}>
                                                      <span style={{paddingRight:"10px"}}>{site.count}</span>
                                                      <AreaChart 
                                                          width={80}
                                                          height={20}
                                                          data={mhdbcounts?.subjectsPerAEPerMonth.filter(item => item.study_ae_bank_event_title === site.study_ae_bank_event_title).map((item) => {
                                                            const month = item.month;
                                                            const monthIndex = parseInt(month) - 1;
                                                            const name = months[monthIndex]
                                                          
                                                            return {
                                                              name,
                                                              "Month Wise Subjects Registered": item.count,
                                                              amt: item.count // You can set the "amt" value accordingly if needed
                                                            };
                                                          })}
                                                          margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                                                          className=''
                                                          >
                                                            <defs>
                                                              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                                                              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
                                                              </linearGradient>
                                                            </defs>
                                                          <Area type="monotone" dataKey="Month Wise Subjects Registered" stroke="#82ca9d" fillOpacity={1} fill="url(#colorUv)"  dot={null}/>
                                                      </AreaChart >
                                                    </div>
                                                  </div>
                                                  )
                                                }
                                                
                                                )

                                                }     
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>



                </Container>
            </div>
    </div>
  )
}

export default MarketingHeadDashBoard